import Alert from 'react-s-alert';
import AlertLevel from '../components/alert/AlertLevel';
import { t } from './i18nService';
import settingsReader from '../store/readHelpers/SettingsReader';
import sessionReader from '../store/readHelpers/SessionReader';
import storeManager from '../store/StoreManager';

export const defaultAlertOptions = {
    offset: 5,
    position: 'top-right',
    timeout: 4000,
};

const alertService = {
    showInvalidTokenAlert() {
        return alertService.showAlert('reload', {
            html: true,
            timeout: 'none',
            customFields: {
                type: 'wrong_token',
                level: AlertLevel.INFO,
            },
        });
    },

    showEssayEditorUnableToSaveAlert() {
        return alertService.showAlert(t('alert.essay.unableToSave'), {
            html: true,
            timeout: 'none',
            customFields: {
                level: AlertLevel.ERROR,
            },
        });
    },

    showDeliveringUnavailableAlert() {
        return alertService.showAlert(
            t('deliver.deliveringNotAvailable'),
            { html: true, timeout: 20000 }
        );
    },

    removedAnnotationItem(isHighlight) {
        return alertService.showAlert('remove', {
            html: true,
            timeout: 4000,
            customFields: {
                type: 'removed_annotation_item',
                level: AlertLevel.INFO,
                isHighlight,
            },
        });
    },

    showServerErrorAlert() {
        alertService.showAlert(
            t('status.serverProblem'),
            {
                html: true,
                timeout: 'none',
                customFields: {
                    subject: t('status.serverProblem'),
                    body: t('status.serverProblemText'),
                    type: 'connectivity',
                },
            }
        );
    },

    showConnectionLostAlert() {
        let body = t('status.connectionLostText');
        if (sessionReader.isParentTest()) {
            const { showLostConnectionAlert, customLostConnectionAlertMessage } = storeManager.getState().parentTest;
            if (!showLostConnectionAlert) {
                return false;
            }
            if (customLostConnectionAlertMessage?.length > 0) {
                body = customLostConnectionAlertMessage.replace(/\\"/g, '"');
            }
        } else if (settingsReader.showLostConnectionAlert()) {
            const customLostConnectionAlertMessage = settingsReader.getCustomLostConnectionAlertMessage();
            if (customLostConnectionAlertMessage?.length > 0) {
                body = settingsReader.getCustomLostConnectionAlertMessage();
            }
        } else {
            return false;
        }

        return alertService.showAlert(
            t('status.disconnected'),
            {
                html: true,
                timeout: 'none',
                customFields: {
                    subject: t('status.connectionLost'),
                    body,
                    type: 'connectivity',
                },
            }
        );
    },

    showAlert(alertText, options = {}) {
        const opts = { ...defaultAlertOptions, ...options };
        const { level } = (opts.customFields || {});

        if (level === AlertLevel.WARNING) {
            return Alert.warning(alertText, opts);
        } else if (level === AlertLevel.ERROR) {
            return Alert.error(alertText, opts);
        } else if (level === AlertLevel.SUCCESS) {
            return Alert.success(alertText, opts);
        }
        return Alert.info(alertText, opts);
    },

    showMessage(message) {
        const customObj = Object.assign(message, { type: 'message' });
        return alertService.showAlert(message.body, {
            html: true,
            timeout: 'none',
            customFields: customObj,
        });
    },

    showError(message, onClose) {
        const customFields = {
            level: AlertLevel.ERROR,
        };
        return alertService.showAlert(message, {
            timeout: 'none',
            onClose,
            customFields,
        });
    },

    showMessageWithDelay(message, messageIndex = 1) {
        return setTimeout(() => {
            alertService.showMessage(message);
        }, messageIndex * 4000);
    },

    showRemoteOralInvisibleContentWarning() {
        return this.showAlert(
            t('remoteOralExam.inProgress.invisibleContent'),
            { timeout: 'none' }
        );
    },
};

export default alertService;
